import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

/**
 * `FeatureDetailsBlock` component properties.
 */
export interface Props {
  title: string;
  details: string;
  justification: 'left' | 'right';
}


const __default__ = { name: 'FeatureDetailsBlock' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    details: null,
    justification: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  details: string;
  justification: 'left' | 'right';
};



const classList = computed(() => {
  const classList: string[] = ['feature-details-block'];

  if (props.justification === 'left') {
    classList.push('justified-left');
  } else {
    classList.push('justified-right');
  }

  return classList;
});

return { __sfc: true,props, classList }
}

})